<template>
  <md-table
    v-model="employees"
    class="mt-2"
    md-sort="name"
    md-sort-order="asc"
    table-header-color="primary"
    @md-selected="onSelect"
  >
    <md-table-empty-state md-label="No records found">
      <md-progress-spinner
        class="mx-3"
        :md-diameter="30"
        :md-stroke="loading ? 4 : 0"
        md-mode="indeterminate"
      ></md-progress-spinner>
    </md-table-empty-state>
    <md-table-row
      slot="md-table-row"
      slot-scope="{ item }"
      :md-selectable="selectable ? 'multiple' : undefined"
      :md-auto-select="selectable"
    >
      <md-table-cell md-label="Full Name" md-sort-by="first_name">
        {{ item.first_name }} {{ item.last_name }}
      </md-table-cell>
      <md-table-cell md-label="Market Access Passes">
        <ul class="list-unstyled mb-0 gap-y-1">
          <li v-for="(pass, id) in item.passes" :key="id">{{ pass.name }}</li>
        </ul>
      </md-table-cell>
      <md-table-cell md-label="Expires">
        <ul class="list-unstyled mb-0 gap-y-1">
          <li v-for="(pass, id) in item.passes" :key="id">
            {{
              pass.expires_at
                ? $moment(pass.expires_at)
                    .subtract(1, "days")
                    .format("DD/MM/YYYY")
                : "Renews 1st July"
            }}
          </li>
        </ul>
      </md-table-cell>
      <md-table-cell md-label="Business Role">
        <span v-if="!editable">
          {{ item.business_manager ? "Business Manager" : "Employee" }}
        </span>
        <md-field
          v-else
          style="margin: 0; padding: 0; min-height: 0"
          class="align-items-center"
        >
          <md-select
            v-model="item.business_manager"
            md-dense
            :disabled="item.loading"
            @input="updateRole(item)"
          >
            <md-option value="true">Business Manager</md-option>
            <md-option value="false">Employee</md-option>
          </md-select>
          <div>
            <md-progress-spinner
              class="mx-3"
              :md-diameter="20"
              :md-stroke="item.loading ? 3 : 0"
              md-mode="indeterminate"
            />
          </div>
        </md-field>
      </md-table-cell>
      <md-table-cell md-label="Registered">
        <i class="fas" :class="item.is_setup ? 'fa-check' : 'fa-times'"></i>
      </md-table-cell>
    </md-table-row>
  </md-table>
</template>
<script>
import ApiService from "@/services/api";

export default {
  name: "EmployeePassTable",
  props: {
    dataBackgroundColor: {
      type: String,
      default: ""
    },
    editable: {
      type: Boolean,
      default: false
    },
    selectable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      employees: [],
      loading: false
    };
  },
  created() {
    this.updateTable();
  },
  methods: {
    updateTable() {
      this.loading = true;
      ApiService.business
        .getBusinessUsers(this.$store.getters.authUser.business_id)
        .then(response => {
          this.employees = response.data.data.users;
          this.employees.forEach(item => {
            this.$set(item, "new_pass", {
              name: "",
              price: 0,
              type: "none"
            });

            this.$set(item, "loading", false);
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSelect(items) {
      this.$emit("selected", items);
    },
    updateRole(employee) {
      if (employee.loading) return;

      employee.loading = true;

      const data = {
        business_manager: employee.business_manager
      };

      ApiService.user
        .updateRole(employee.id, data)
        .then(() => {
          this.$toast.success("Role updated successfully.");
        })
        .catch(error => {
          // reset select
          employee.business_manager =
            data.business_manager === "true" ? "false" : "true";

          if (error.response) {
            this.$toast.error(error.response.data.message);
          }
        })
        .finally(() => {
          employee.loading = false;
        });
    }
  }
};
</script>
<style>
.gap-y-1 li {
  margin-bottom: 0.75em;
}

.gap-y-1 li:last-child {
  margin-bottom: 0;
}
</style>
